import { useState } from "react";
import { Link } from "react-router-dom";
import { useHouseholdContext } from "@/contexts/HouseholdContext";

export function Header() {
  const { household, allHouseholds, switchHousehold } = useHouseholdContext();
  const [showPicker, setShowPicker] = useState(false);
  const hasMultiple = allHouseholds.length > 1;

  return (
    <header
      className="sticky top-0 z-40 px-4 py-3 flex items-center justify-between"
      style={{ backgroundColor: "var(--accent-color)" }}
    >
      <div className="flex items-center gap-2">
        <button
          onClick={() => hasMultiple && setShowPicker(!showPicker)}
          className="text-white font-bold text-lg flex items-center gap-1"
        >
          {household?.household_label ?? "Zoey"}
          {hasMultiple && (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          )}
        </button>
      </div>

      <div className="flex items-center gap-3">
        <Link to="/posts" className="text-white" aria-label="New post">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M12 20h9" /><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
          </svg>
        </Link>
        <Link to="/notifications" className="text-white relative" aria-label="Notifications">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 0 1-3.46 0" />
          </svg>
        </Link>
      </div>

      {showPicker && (
        <div className="absolute top-full left-4 mt-1 bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 min-w-[200px] z-50">
          {allHouseholds.map((hh) => (
            <button
              key={hh.uid}
              onClick={() => {
                if (hh.uid) switchHousehold(hh.uid);
                setShowPicker(false);
              }}
              className={`w-full text-left px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 first:rounded-t-xl last:rounded-b-xl ${
                hh.uid === household?.uid ? "font-bold" : ""
              }`}
            >
              {hh.household_label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
